import { render } from "./ChooseWork.vue?vue&type=template&id=5bc1efbc&scoped=true"
import script from "./ChooseWork.vue?vue&type=script&lang=js"
export * from "./ChooseWork.vue?vue&type=script&lang=js"

import "./ChooseWork.vue?vue&type=style&index=0&id=5bc1efbc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5bc1efbc"

export default script